import Successful from './successful';
import Reject from './reject';

export default {
  success: Successful,
  reject: Reject,
};
